import { render, staticRenderFns } from "./gl-button.vue?vue&type=template&id=39e69b68"
import script from "./gl-button.vue?vue&type=script&lang=js"
export * from "./gl-button.vue?vue&type=script&lang=js"
import style0 from "./gl-button.vue?vue&type=style&index=0&id=39e69b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports